import t from 'react-translate';
import { useContext } from 'react';
import { IntegrationTypes, SessionTypes } from 'redux/schemas/models/live-event';
import { config } from '@config/pendo.config.json';
import {
  mappingIntegrationType,
  translationIntegrationKeys,
} from 'redux/schemas/models/mentoring-program-sessions';

import { css } from '@emotion/react';
import { success, white } from 'styles/global_defaults/colors';

import { Button } from 'react-bootstrap';
import NvIcon from 'shared/components/nv-icon';
import MentoringProgramContext from 'athena/components/mentoring-program/context';

const styles = css`
  .connected-status {
    border-radius: 180px;
    i {
      color: ${success};
    }
  }
  .bs4-btn-primary {
    &:hover, &:focus {
      color: ${white};
    }
  }
`;

type AuthenticateIntegrationProps = {
  integration: IntegrationTypes;
  isAuthenticated: boolean;
  authenticationEmail: string;
  onClick: (integration: string) => void;
};

const AuthenticateIntegration = (props: AuthenticateIntegrationProps) => {
  const {
    integration,
    isAuthenticated,
    authenticationEmail,
    onClick,
  } = props;

  const translationsBase = t.MENTORING_PROGRAMS.PARTICIPANT_HOME.PLAN_SESSION_FLYOUT.ENABLE_INTEGRATIONS_MODAL;
  const translationKey = integration === mappingIntegrationType[SessionTypes.MS_TEAMS]
    ? translationIntegrationKeys[SessionTypes.MS_TEAMS]
    : translationIntegrationKeys[SessionTypes.ZOOM];
  const translations = translationsBase[translationKey];

  const { mentoringProgram } = useContext(MentoringProgramContext);
  const dataQa = config.pendo.athena.mentorshipProgram.participantHome.sessions.planSessionFlyout.virtualMeeting.authenticate;
  const dataQaId = `${dataQa}_${mentoringProgram?.id}`;

  return (
    <div css={styles} className='d-flex align-items-center p-4 bg-gray-6 mx-6'>
      <div className='integration-titles mr-2 flex-grow-1'>
        <div className='integration-title semi-bold mb-2'>
          {translations.TITLE()}
        </div>
        <div className='integration-subtitle'>
          {translations.DESCRIPTION()}
        </div>
        {authenticationEmail && (
          <div className='authenticated-email mt-2'>
            {translations.AUTHENTICATED_EMAIL(authenticationEmail)}
          </div>
        )}
      </div>
      {isAuthenticated ? (
        <div className='connected-status bg-white py-2 px-3 bold d-flex align-items-center'>
          <NvIcon icon='check' size='xss-smallest' className='mr-1' />
          {translationsBase.CONNECTED()}
        </div>
      ) : (
        <Button
          variant='primary'
          className='btn btn-secondary'
          onClick={() => {
            onClick(integration);
          }}
          data-qa={dataQa}
          data-qa-id={dataQaId}
          aria-label={translationsBase.AUTHENTICATE()}
        >
          {translationsBase.AUTHENTICATE()}
        </Button>
      )}
    </div>
  );
};

export default AuthenticateIntegration;
